import { IApplicationState } from '../../types/redux';

export function selectIsWebGlRendering(state: IApplicationState): boolean {
  return state.infrastructure.config.webGl;
}
